const STRIPE_PENDING_KEY = 'fdh_stripe_checkout_pending';
const STRIPE_PENDING_AT_KEY = 'fdh_stripe_checkout_pending_at';
const STRIPE_PENDING_MAX_AGE_MS = 30 * 60 * 1000;

/** Whether a URL belongs to Stripe (checkout, billing portal, etc.). */
export const isStripeUrl = (url: string): boolean => {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return host === 'stripe.com' || host.endsWith('.stripe.com');
  } catch {
    return false;
  }
};

/** Mark that the user is about to leave for Stripe checkout or billing portal. */
export const markStripeCheckoutPending = (): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(STRIPE_PENDING_KEY, '1');
  sessionStorage.setItem(STRIPE_PENDING_AT_KEY, String(Date.now()));
};

const clearStripeCheckoutPending = (): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(STRIPE_PENDING_KEY);
  sessionStorage.removeItem(STRIPE_PENDING_AT_KEY);
};

const hasRecentStripeCheckoutPending = (): boolean => {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  if (sessionStorage.getItem(STRIPE_PENDING_KEY) !== '1') {
    return false;
  }
  const pendingAt = Number(sessionStorage.getItem(STRIPE_PENDING_AT_KEY) ?? 0);
  if (!pendingAt || Date.now() - pendingAt > STRIPE_PENDING_MAX_AGE_MS) {
    clearStripeCheckoutPending();
    return false;
  }
  return true;
};

/** Detect whether the subscription page was opened right after returning from Stripe. */
export const detectReturnedFromStripe = (checkoutResult: string | null): boolean => {
  if (checkoutResult === 'success' || checkoutResult === 'cancel') {
    clearStripeCheckoutPending();
    return true;
  }
  if (typeof document !== 'undefined' && document.referrer && isStripeUrl(document.referrer)) {
    clearStripeCheckoutPending();
    return true;
  }
  if (hasRecentStripeCheckoutPending()) {
    clearStripeCheckoutPending();
    return true;
  }
  return false;
};
